// This icon file is generated automatically.
var PtoCheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M28.5 5.94h-2.18a1 1 0 00-.79.38L12.65 22.64l-6.18-7.83a1 1 0 00-.79-.38H3.5c-.2 0-.33.24-.2.4l8.56 10.85a1 1 0 001.57 0L28.7 6.34a.25.25 0 00-.2-.4z", "fill-rule": "nonzero" } }] }, "name": "pto-check", "theme": "outlined" };
export default PtoCheckOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoCheckOutlined.js
// module id = 3885
// module chunks = 0